import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UnlinkBankAccountRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UnlinkBankAccountResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const unlinkBankAccount = (request: UnlinkBankAccountRequest, options?: CashRequestOptions) =>
  post<UnlinkBankAccountRequest, UnlinkBankAccountResponse>('/2.0/cash/unlink-bank-account', request, {
    ...options,
    rejectOnError: true,
  })
